import { render } from "./LocationDetails.vue?vue&type=template&id=67428836&scoped=true"
import script from "./LocationDetails.vue?vue&type=script&lang=js"
export * from "./LocationDetails.vue?vue&type=script&lang=js"

import "./LocationDetails.vue?vue&type=style&index=0&id=67428836&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67428836"]])

export default __exports__